<template lang="pug">
v-container 
  
  v-layout Credenciales
    v-spacer
    v-btn( @click='agregar()' color='primary' )
      v-icon fas fa-plus
  v-layout.mt-5.wrap
    template(v-for='credencial in registro_de_credenciales')
      v-flex.sm12.md6.pa-1
        v-card
          v-card-title
            v-layout
              v-edit-dialog( :return-value.sync='credencial.nombre' label='Nombre' @save='actualizar({key: credencial.key, credencial: credencial})' ) {{credencial.nombre ? credencial.nombre : 'Nombre'}}
                template(v-slot:input='')
                  v-text-field(v-model='credencial.nombre' label='Edit' single-line)
              v-spacer
              v-btn( @click='eliminar_valor(credencial.key, credencial.valores)' icon  )
                v-icon( small ) fas fa-minus
              v-btn( @click='agregar_valor(credencial.key, credencial.valores)' icon  )
                v-icon( small ) fas fa-plus
              v-btn( @click='eliminar(credencial.key)' icon )
                v-icon( small ) far fa-trash-alt
              
          v-data-table(:headers='encabezado' :items='credencial.valores' hide-default-footer hide-default-header )
            template( v-slot:item.descripcion="{item}")
              v-edit-dialog( :return-value.sync="item.descripcion" @save='actualizar({key: credencial.key, credencial: credencial})') {{ item.descripcion ? item.descripcion : 'Descripcion'}}
                template( v-slot:input)
                  v-text-field(v-model='item.descripcion' label='Edit' single-line)
            template( v-slot:item.valor="{item}")
              v-edit-dialog( :return-value.sync="item.valor" @save='actualizar({key: credencial.key, credencial: credencial})') {{ item.valor ? item.valor : 'Valor'}}
                template( v-slot:input)
                  v-text-field(v-model='item.valor' label='Edit' single-line)
                

</template>

<script>
import {mapActions, mapState, mapGetters} from 'vuex'
import {storage} from '@/FirebaseConfig'

  export default {
    data () {
      return {
        encabezado: [
          { text: 'Descripción', sortable: false, value: 'descripcion' },
          { text: 'Valor',  sortable: false,  value: 'valor' },
        ],
      }
    },
    computed: {
      ...mapGetters({
        registro_de_credenciales: 'Credenciales/registro'
      })
    },
    methods: {
      ...mapActions({
        agregar: 'Credenciales/agregar',
        obtener_todo: 'Credenciales/obtener_todo',
        eliminar: 'Credenciales/eliminar',
        actualizar: 'Credenciales/actualizar'
      }),
      agregar_valor (key, valores) {
        valores.push({
          descripcion: '',
          valor: '',
        })
      },
      eliminar_valor (key, valores){
        valores.splice(valores.length-1)
      },
    
    }
  }
</script>